import React, { useState } from 'react'

function Youtube() {
    const [hover, setHover] = useState('https://www.youtube.com/embed/DS_hlhYKYgA');

    return(
        <div className='youtube-wrapper'>
            <iframe
                title='youtube-player'
                className='youtube-player'
                src={hover}
            />
            <div className='youtube-lists'>
                <div 
                    className='youtube-list pointer'
                    onMouseEnter={() => setHover('https://www.youtube.com/embed/DS_hlhYKYgA')} 
                >
                    <span>소연이의 첫 팬미팅 같이 보쟈🌈</span>
                </div>
                <div 
                    className='youtube-list pointer'
                    onMouseEnter={() => setHover('https://www.youtube.com/embed/u2HESyL8IF0')} 
                >
                    임창정(Im Chang Jung) - 멍청이 coverd by 숏태림
                </div>
            </div>
        </div>
    );
}

export default Youtube;